import { DateYMDString } from "../../models";

/** Cell id: `YYYY-MM-DD_<hour>` with hour 0–24 (split on last `_`). */
export type CoursesCalendarCellId = string;

export const toCoursesCalendarCellId = (
  date: DateYMDString,
  hourIndex: number,
): CoursesCalendarCellId => `${date}_${String(hourIndex)}`;
